const Inputmask = require('inputmask').default;
const Marionette = require('backbone.marionette');

Inputmask.extendDefaults({
    autoUnmask: true,
    rightAlign: false
});

Inputmask.extendAliases({
    currency: {
        autoUnmask: true,
        rightAlign: false
    },
    decimal: {
        autoUnmask: true,
        rightAlign: false
    },
    integer: {
        autoUnmask: true,
        rightAlign: false
    }
});

// Example usage:
// behaviors: {
//     InputMask: {
//         '#aNumberBox': 'decimal',
//         '#aMoneyBox': 'currency',
//         '#tenNines': { mask: "9, repeat: 10 },
//         '#regex': { regex: "\\d*" },
//         '#dynamic': (view) => view.model.get('useIntegerMask') ? 'integer' : 'decimal'
//     },
// },
//
// Each (key, value) pair of the InputMask object will be used as a selector to determine what elements the mask will be applied to, and the parameters for the mask, respectively.
// You can pass in either a parameter object as in #tenNines or use an 'alias' string as in #aNumberBox and #aMoneyBox.
// Built in aliases: email, currency, decimal, integer, date, datetime, dd/mm/yyyy, etc.
// The library won't work with type="number", so just use type="text". If you have a number field, you'll still need to configure onSet on stickit to parse the unmasked string.
//
// Inputmask docs: https://www.npmjs.com/package/inputmask

module.exports = Marionette.Behavior.extend({
    onDomRefresh: function () {
        let selectors = _.keys(this.options);
        selectors.forEach(selector => {
            let mask = this.options[selector];
            if (_.isFunction(mask)) {
                mask = mask(this.view);
            }
            let els = this.view.el.querySelectorAll(selector)
            els.forEach(el => Inputmask(mask).mask(el));
        });
    },
});
